var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectmarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svgWidth",
    width: 731,
    height: 762,
    viewBox: "0 0 731 762",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M27.3898 740.62C27.3898 740.62 -8.04531 648.49 19.5396 546.058C50.745 430.16 133.546 411.235 174.233 341.568C214.921 271.901 214.875 123.768 286.171 60.7345C338.961 14.0616 377.902 24.2761 440.658 88.3934C503.413 152.511 528.401 109.685 598.581 148.796C674.67 191.202 706.852 333.586 686.554 479.729C669.44 602.901 720.07 627.862 717.771 740.62H27.3898Z",
    fill: "url(#paint0_linear_2197_5367)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M372.02 454.702H326.757C324.815 454.702 323.24 451.673 323.24 447.936V392.906C323.24 389.169 324.815 386.14 326.757 386.14H372.02C373.962 386.14 375.537 389.169 375.537 392.906V447.936C375.537 451.673 373.962 454.702 372.02 454.702Z",
    fill: "url(#paint1_linear_2197_5367)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M370.996 450.302H323.171C321.941 450.302 320.93 448.378 320.93 445.991V386.03C320.93 383.664 321.93 381.719 323.171 381.719H370.996C372.226 381.719 373.238 383.642 373.238 386.03V445.991C373.238 448.356 372.238 450.302 370.996 450.302Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M359.193 427.22C356.929 423.461 354.63 419.725 352.343 416.01C354.642 412.296 356.929 408.581 359.193 404.801C361.113 401.617 363.009 398.411 364.906 395.183C366.768 391.889 368.676 388.683 370.515 385.322C368.446 388.152 366.446 391.115 364.411 394.011C362.4 396.974 360.4 399.937 358.412 402.944C354.596 408.692 350.837 414.551 347.102 420.454L341.723 412.031C339.746 409.002 337.781 405.928 335.781 402.944C333.792 399.937 331.792 396.952 329.781 394.011C327.747 391.115 325.747 388.13 323.678 385.3C325.517 388.661 327.413 391.867 329.287 395.161C331.183 398.389 333.08 401.617 334.999 404.779C336.907 407.985 338.849 411.102 340.769 414.264L341.849 415.988L340.769 417.713C338.849 420.874 336.907 423.992 334.999 427.198C333.091 430.381 331.183 433.587 329.298 436.837C327.425 440.11 325.528 443.315 323.689 446.698C325.758 443.868 327.758 440.883 329.792 437.987C331.804 435.024 333.804 432.062 335.792 429.055C337.792 426.07 339.757 422.997 341.734 419.968L343.056 417.912L346.608 423.594L347.113 424.412L347.619 423.594C348.803 421.714 349.987 419.791 351.171 417.912C353.573 421.67 355.998 425.385 358.435 429.055C360.423 432.062 362.423 435.024 364.434 437.987C366.469 440.883 368.469 443.868 370.538 446.698C368.699 443.315 366.802 440.109 364.929 436.815C363.009 433.609 361.113 430.403 359.193 427.22Z",
    fill: "url(#paint2_linear_2197_5367)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M377.455 385.3C377.455 393.835 373.858 400.733 369.433 400.733C364.996 400.733 361.41 393.812 361.41 385.3C361.41 376.766 365.008 369.868 369.433 369.868C373.858 369.868 377.455 376.788 377.455 385.3Z",
    fill: "url(#paint3_linear_2197_5367)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M368.595 392.574C368.376 392.574 368.17 392.397 368.032 392.066L364.974 385.256C364.71 384.659 364.744 383.753 365.055 383.222C365.365 382.691 365.836 382.758 366.112 383.377L368.618 388.948L372.79 380.038C373.066 379.441 373.537 379.397 373.847 379.928C374.158 380.458 374.181 381.365 373.905 381.962L369.17 392.088C369.009 392.397 368.813 392.574 368.595 392.574Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M327.662 194.938C325.421 189.146 324.249 181.717 324.743 173.736C325.57 160.448 331.122 149.681 338.03 148.022C347.397 145.789 355.362 159.785 355.362 177.339C355.362 193.413 348.949 206.258 340.604 206.878C337.328 207.121 334.271 205.396 331.731 202.257C331.559 202.036 331.34 202.013 331.156 202.19L325.398 207.917C325.145 208.16 324.881 207.673 324.996 207.187L327.72 196.044C327.812 195.69 327.789 195.27 327.662 194.938Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M347.353 181.584C348.368 181.584 349.192 180.001 349.192 178.047C349.192 176.093 348.368 174.509 347.353 174.509C346.337 174.509 345.514 176.093 345.514 178.047C345.514 180.001 346.337 181.584 347.353 181.584Z",
    fill: "url(#paint4_linear_2197_5367)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M338.156 178.047C338.156 179.993 338.984 181.584 339.995 181.584C341.007 181.584 341.834 179.993 341.834 178.047C341.834 176.101 341.007 174.509 339.995 174.509C338.972 174.509 338.156 176.101 338.156 178.047Z",
    fill: "url(#paint5_linear_2197_5367)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M332.628 181.584C333.644 181.584 334.467 180.001 334.467 178.047C334.467 176.093 333.644 174.509 332.628 174.509C331.612 174.509 330.789 176.093 330.789 178.047C330.789 180.001 331.612 181.584 332.628 181.584Z",
    fill: "url(#paint6_linear_2197_5367)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M729.851 745.042H1.14937C0.517217 745.042 0 744.047 0 742.831C0 741.615 0.517217 740.62 1.14937 740.62H729.851C730.483 740.62 731 741.615 731 742.831C731 744.047 730.483 745.042 729.851 745.042Z",
    fill: "url(#paint7_linear_2197_5367)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M235.609 762H162.636C162.004 762 161.486 761.005 161.486 759.789C161.486 758.573 162.004 757.578 162.636 757.578H235.609C236.241 757.578 236.759 758.573 236.759 759.789C236.759 761.005 236.241 762 235.609 762Z",
    fill: "url(#paint8_linear_2197_5367)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M584.594 762H509.644C509.011 762 508.494 761.005 508.494 759.789C508.494 758.573 509.011 757.578 509.644 757.578H584.594C585.226 757.578 585.743 758.573 585.743 759.789C585.743 761.005 585.226 762 584.594 762Z",
    fill: "url(#paint9_linear_2197_5367)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M308.239 762H265.712C265.08 762 264.562 761.005 264.562 759.789C264.562 758.573 265.08 757.578 265.712 757.578H308.239C308.871 757.578 309.388 758.573 309.388 759.789C309.388 761.005 308.871 762 308.239 762Z",
    fill: "url(#paint10_linear_2197_5367)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M605.386 762H589.433C588.8 762 588.283 761.005 588.283 759.789C588.283 758.573 588.8 757.578 589.433 757.578H605.386C606.018 757.578 606.535 758.573 606.535 759.789C606.535 761.005 606.018 762 605.386 762Z",
    fill: "url(#paint11_linear_2197_5367)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M295.287 576.215C295.551 563.745 297.241 551.076 301.091 541.039C302.286 537.944 304.482 534.892 306.091 537.192C306.688 538.032 306.999 539.403 307.252 540.751C309.229 551.298 308.746 562.971 307.608 573.96C307.447 575.485 307.286 577.011 307.102 578.536C310.033 564.939 314.228 552.116 318.803 540.309C320.826 535.069 323.032 529.807 326.032 526.778C327.572 525.231 329.492 524.346 331.009 525.96C333.239 528.326 333.354 534.384 332.86 539.182C330.538 561.932 321.849 579.332 314.573 598.214C321.757 585.213 331.756 568.941 340.457 570.356C344.733 571.041 348.732 578.868 343.583 589.569C337.457 602.304 318.734 606.704 314.86 628.614C326.768 614.928 331.825 613.226 337.193 614.177C343.273 615.238 347.031 628.106 343.296 635.932C340.721 641.327 336.4 641.835 332.607 641.062C328.469 640.199 324.377 638.254 320.217 638.033C316.056 637.812 311.631 639.558 308.596 645.063L297.298 613.403C296.091 601.132 295.022 588.707 295.287 576.215Z",
    fill: "url(#paint12_linear_2197_5367)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5748 655.72C35.3216 638.32 54.5046 661.668 63.826 676.017C53.631 657.776 42.0224 641.791 36.9652 617.25C35.8962 612.076 35.4135 605.355 37.6088 601.707C40.988 596.069 49.9875 607.831 52.815 612.872C59.217 624.281 64.2397 639.094 68.9981 653.133C66.9293 639.116 63.0674 623.75 60.3663 612.651C57.4699 600.712 58.1596 591.161 61.5387 590.276C69.8946 588.088 77.5609 627.376 79.3425 639.58C80.7907 626.226 84.733 608.76 92.5832 607.234C94.8475 606.792 97.2267 610.551 97.7324 617.604C99.422 641.349 85.9858 663.016 86.5375 686.939L75.584 726.028C71.5957 721.098 66.458 720.899 61.8146 722.822C57.1711 724.746 52.815 728.549 48.275 731.157C44.1142 733.545 32.2642 736.442 28.7931 731.423C23.7704 724.171 26.3565 711.502 33.4941 707.08C39.3329 703.476 47.1486 699.541 66.7913 710.131C59.8951 692.488 45.2981 690.189 35.0802 684.838C26.0461 680.151 22.8394 663.171 26.5748 655.72Z",
    fill: "url(#paint13_linear_2197_5367)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M158.912 706.616C158.912 706.616 139.166 647.296 127.615 679.598C117.512 707.832 154.073 721.562 154.073 721.562",
    fill: "url(#paint14_linear_2197_5367)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3535 740.62H397.719C397.535 739.294 396.42 737.039 393.42 733.368C387.007 725.409 366.755 732.55 366.755 732.55C366.755 732.55 371.467 728.924 371.444 724.215C371.421 719.528 369.57 715.416 367.364 713.448C365.134 711.524 362.605 711.37 360.169 711.635C355.215 712.188 350.307 714.31 345.698 717.87C347.652 715.526 348.25 709.866 346.928 706.307C345.595 702.703 342.606 701.951 340.836 704.759C343.951 696.667 351.25 655.853 336.469 640.023C317.941 620.19 301.378 641.393 298.378 653.332C296.861 641.614 289.873 632.682 285.264 630.538C263.288 620.367 247.243 656.671 247.036 657.29C246.829 656.671 246.599 656.052 246.369 655.433C244.071 649.552 239.427 638.939 235.945 635.822C226.14 627.022 219.313 625.519 208.796 630.538C204.188 632.726 197.199 641.614 195.682 653.332C192.682 641.393 178.614 625.077 160.086 644.909C145.305 660.739 150.11 696.667 153.224 704.759C151.454 701.951 148.466 702.703 147.133 706.307C145.811 709.888 146.397 715.548 148.363 717.87C143.754 714.288 130.053 706.505 123.95 713.05C117.226 720.258 127.306 732.528 127.306 732.528C127.306 732.528 110.33 721.54 100.848 730.384C97.6638 733.39 96.3535 738.542 96.3535 740.62Z",
    fill: "url(#paint15_linear_2197_5367)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M637.465 740.62C637.465 740.62 625.259 732.882 623.719 711.524C622.19 690.145 635.787 692.355 640.58 711.524C640.58 711.524 633.523 681.433 641.224 674.933C649.315 668.102 652.453 683.313 652.648 696.866C652.648 696.866 655.395 683.379 660.499 688.995C665.269 694.213 659.545 710.795 659.545 710.795C659.545 710.795 667.786 691.825 674.291 705.267C681.624 720.412 664.142 740.642 664.142 740.642H637.465V740.62Z",
    fill: "url(#paint16_linear_2197_5367)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M149.131 146.099L146.924 163.985H243.437C256.068 163.985 268.114 183.685 270.332 207.983L311.997 662.552C312.1 663.724 312.18 664.874 312.238 666.023L314.893 662.066L319.743 659.7C319.743 659.7 316.617 706.97 293.158 706.55H193.347C180.715 706.55 168.67 686.85 166.452 662.552L124.787 207.983C124.638 206.303 124.534 204.645 124.477 203.008C119.684 148.929 149.131 146.099 149.131 146.099Z",
    fill: "url(#paint17_linear_2197_5367)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M201.128 688.42H300.94C313.571 688.42 322.008 668.72 319.778 644.422L278.113 189.853C275.883 165.555 263.838 145.856 251.218 145.856H151.406C138.775 145.856 130.339 165.555 132.568 189.853L174.233 644.422C176.451 668.743 188.497 688.42 201.128 688.42Z",
    fill: "url(#paint18_linear_2197_5367)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M137.108 190.76L178.577 643.096C180.45 663.569 190.599 680.151 201.242 680.151H299.307C309.95 680.151 317.053 663.547 315.18 643.096L273.722 190.76C271.802 169.756 261.389 152.732 250.47 152.732H242.62C240.448 152.732 238.735 155.341 238.356 159.276L236.884 174.288C236.528 177.848 234.988 180.236 233.011 180.236H175.91C173.933 180.236 171.956 177.87 170.945 174.288L166.727 159.298C165.623 155.363 163.44 152.754 161.256 152.754H153.406C142.475 152.732 135.188 169.756 137.108 190.76Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M189.38 169.424H221.459C222.677 169.424 223.482 167.523 223.275 165.179C223.057 162.836 221.896 160.934 220.689 160.934H188.61C187.392 160.934 186.587 162.836 186.794 165.179C187.013 167.523 188.162 169.424 189.38 169.424Z",
    fill: "url(#paint19_linear_2197_5367)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M178.945 165.179C179.164 167.523 180.324 169.424 181.531 169.424C182.75 169.424 183.554 167.523 183.347 165.179C183.129 162.836 181.968 160.934 180.761 160.934C179.554 160.934 178.727 162.836 178.945 165.179Z",
    fill: "url(#paint20_linear_2197_5367)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M132.256 252.224L132.198 251.605H133.428C134.876 251.605 136.256 253.86 136.509 256.646L142.324 320.1C142.577 322.885 141.612 325.141 140.164 325.141H138.934L138.876 324.522C137.98 323.681 137.256 322.023 137.083 320.1L131.267 256.646C131.095 254.722 131.509 253.086 132.256 252.224Z",
    fill: "url(#paint21_linear_2197_5367)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M138.946 325.141C140.394 325.141 141.36 322.885 141.107 320.1L135.291 256.646C135.038 253.86 133.659 251.605 132.211 251.605C130.763 251.605 129.797 253.86 130.05 256.646L135.866 320.1C136.119 322.885 137.498 325.141 138.946 325.141Z",
    fill: "url(#paint22_linear_2197_5367)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M169.185 248.863C169.553 252.931 169.174 256.668 168.231 259.631C166.944 263.677 164.611 266.263 161.726 266.263C158.841 266.263 156.036 263.677 154.013 259.631C152.531 256.668 151.462 252.931 151.094 248.863C150.221 239.246 153.554 231.463 158.554 231.463C163.542 231.463 168.312 239.246 169.185 248.863Z",
    fill: "url(#paint23_linear_2197_5367)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M186.77 532.173C187.092 535.644 185.885 538.452 184.081 538.452C182.276 538.452 180.563 535.644 180.253 532.173C179.931 528.702 181.138 525.894 182.943 525.894C184.736 525.894 186.448 528.702 186.77 532.173Z",
    fill: "url(#paint24_linear_2197_5367)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M182.069 532.173C182.391 535.644 181.184 538.452 179.379 538.452C177.575 538.452 175.862 535.644 175.552 532.173C175.23 528.702 176.437 525.894 178.241 525.894C180.034 525.894 181.747 528.702 182.069 532.173Z",
    fill: "url(#paint25_linear_2197_5367)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M269.985 242.761C269.916 241.965 270.192 241.324 270.606 241.324C271.02 241.324 271.41 241.965 271.491 242.761C271.56 243.557 271.284 244.198 270.87 244.198C270.456 244.198 270.054 243.557 269.985 242.761Z",
    fill: "url(#paint26_linear_2197_5367)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M267.009 242.761C266.94 241.965 267.216 241.324 267.629 241.324C268.043 241.324 268.434 241.965 268.514 242.761C268.595 243.557 268.307 244.198 267.894 244.198C267.468 244.198 267.078 243.557 267.009 242.761Z",
    fill: "url(#paint27_linear_2197_5367)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M264.02 242.761C263.951 241.965 264.227 241.324 264.641 241.324C265.055 241.324 265.446 241.965 265.526 242.761C265.595 243.557 265.319 244.198 264.905 244.198C264.492 244.198 264.101 243.557 264.02 242.761Z",
    fill: "url(#paint28_linear_2197_5367)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M296.376 515.038H173.485L151.877 278.667H274.768L296.376 515.038Z",
    fill: "url(#paint29_linear_2197_5367)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M309.02 652.912H186.14L180.336 589.48H303.215L309.02 652.912Z",
    fill: "url(#paint30_linear_2197_5367)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M202.026 246.918H175.637C174.89 246.918 174.188 245.768 174.062 244.331L174.028 243.911C173.901 242.474 174.395 241.324 175.131 241.324H201.521C202.268 241.324 202.969 242.474 203.095 243.911L203.13 244.331C203.268 245.768 202.773 246.918 202.026 246.918Z",
    fill: "url(#paint31_linear_2197_5367)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M188.348 256.314H176.498C175.751 256.314 175.05 255.164 174.923 253.727L174.889 253.307C174.762 251.87 175.257 250.72 175.992 250.72H187.842C188.589 250.72 189.29 251.87 189.417 253.307L189.451 253.727C189.589 255.164 189.084 256.314 188.348 256.314Z",
    fill: "url(#paint32_linear_2197_5367)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M238.416 273.736H178.086C177.339 273.736 176.638 272.587 176.511 271.15L176.477 270.729C176.35 269.292 176.845 268.143 177.58 268.143H237.911C238.658 268.143 239.359 269.292 239.485 270.729L239.52 271.15C239.658 272.565 239.163 273.736 238.416 273.736Z",
    fill: "url(#paint33_linear_2197_5367)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M248.725 535.268H192.211C191.464 535.268 190.763 534.119 190.636 532.681L190.602 532.261C190.475 530.824 190.97 529.675 191.705 529.675H248.22C248.967 529.675 249.668 530.824 249.794 532.261L249.829 532.681C249.967 534.119 249.473 535.268 248.725 535.268Z",
    fill: "url(#paint34_linear_2197_5367)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M298.103 548.622H178.396C177.649 548.622 176.948 547.473 176.822 546.036L176.787 545.615C176.661 544.178 177.155 543.029 177.891 543.029H297.598C298.345 543.029 299.046 544.178 299.172 545.615L299.207 546.036C299.333 547.473 298.839 548.622 298.103 548.622Z",
    fill: "url(#paint35_linear_2197_5367)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M299.322 561.976H179.615C178.868 561.976 178.167 560.827 178.041 559.39L178.006 558.97C177.88 557.532 178.374 556.383 179.109 556.383H298.816C299.564 556.383 300.265 557.532 300.391 558.97L300.426 559.39C300.564 560.827 300.069 561.976 299.322 561.976Z",
    fill: "url(#paint36_linear_2197_5367)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M252.39 575.33H180.842C180.095 575.33 179.394 574.181 179.267 572.744L179.233 572.324C179.106 570.886 179.6 569.737 180.336 569.737H251.884C252.631 569.737 253.333 570.886 253.459 572.324L253.493 572.744C253.62 574.181 253.126 575.33 252.39 575.33Z",
    fill: "url(#paint37_linear_2197_5367)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M296.885 535.268H267.266C266.518 535.268 265.817 534.119 265.691 532.681L265.656 532.261C265.53 530.824 266.024 529.675 266.76 529.675H296.379C297.126 529.675 297.827 530.824 297.954 532.261L297.988 532.681C298.115 534.119 297.62 535.268 296.885 535.268Z",
    fill: "url(#paint38_linear_2197_5367)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M264.241 515.038H236.909C235.392 507.565 234.357 502.502 234.357 502.502L236.829 435.024L236.852 434.914L257.678 431.332C257.678 431.332 261.276 468.586 264.241 515.038Z",
    fill: "url(#paint39_linear_2197_5367)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M244.495 435.024C244.495 435.024 237.035 491.16 233.53 515.038H202.934C203.865 505.288 204.876 490.364 205.232 481.83C202.072 449.064 209.623 435.024 209.623 435.024H244.495Z",
    fill: "url(#paint40_linear_2197_5367)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M272.159 319.392L278.722 328.966C278.722 328.966 286.078 287.024 287.779 279.662C288.422 276.832 294.112 277.65 294.112 277.65C294.112 277.65 294.928 345.857 287.308 360.228C280.848 372.411 258.527 337.168 258.527 337.168L272.159 319.392Z",
    fill: "url(#paint41_linear_2197_5367)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M277.791 327.705C277.791 327.705 276.986 336.107 270.469 351.252C269.745 352.91 268.952 354.657 268.09 356.492C266.309 353.839 262.987 349.925 257.504 342.076C256.711 340.949 255.872 339.711 254.987 338.406C245.999 321.78 249.585 291.114 249.585 291.114C249.585 291.114 258.137 294.055 261.194 298.167C266.573 305.353 274.136 319.702 277.791 327.705Z",
    fill: "url(#paint42_linear_2197_5367)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M270.471 351.252C269.747 352.91 268.954 354.657 268.092 356.492C266.31 353.839 262.988 349.925 257.506 342.076L260.828 329.695C260.828 329.695 261.747 338.141 262.322 339.888C262.747 341.17 267.804 347.803 270.471 351.252Z",
    fill: "url(#paint43_linear_2197_5367)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M258.54 373.339C258.54 373.339 261.746 325.362 261.126 307.011C256.919 293.458 247.448 293.281 247.448 293.281L230.392 291.136C230.392 291.136 214.921 300.666 210.875 361.422C210.174 370.509 208.611 405.42 207.611 420.896C207.37 424.633 207.186 428.944 206.99 429.718C205.623 435.135 205.002 441.834 215.691 439.689C226.38 437.545 250.666 453.066 258.39 438.893C260.275 435.444 259.655 429.187 259.471 425.738C259.321 406.216 258.54 373.339 258.54 373.339Z",
    fill: "url(#paint44_linear_2197_5367)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M249.599 291.114C249.599 291.114 249.645 298.853 246.139 299.914C238.829 302.125 230.393 291.114 230.393 291.114C235.933 289.323 234.231 265.401 234.231 265.401L242.99 274.311L247.392 278.777C247.392 278.777 247.622 283.442 248.035 287.621C248.139 288.815 247.76 290.584 249.599 291.114Z",
    fill: "url(#paint45_linear_2197_5367)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M248.023 287.621C241.334 285.211 238.23 273.692 238.23 273.692L242.977 274.311L247.379 278.799C247.379 278.777 247.609 283.442 248.023 287.621Z",
    fill: "url(#paint46_linear_2197_5367)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M227.622 350.456C227.622 350.456 223.048 384.947 221.898 389.656L223.714 411.389L216.795 414.794L215.002 379.972L227.622 350.456Z",
    fill: "url(#paint47_linear_2197_5367)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M227.07 398.301C227.07 398.301 193.647 426.468 188.475 430.359L203.37 484.439L238.955 454.679L227.07 398.301Z",
    fill: "url(#paint48_linear_2197_5367)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M229.094 401.064C229.094 401.064 197.67 427.441 192.498 431.332L204.233 484.439L240.392 456.338L229.094 401.064Z",
    fill: "url(#paint49_linear_2197_5367)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M226.783 459.013C226.071 457.487 224.841 456.669 224.197 455.321C223.554 453.972 222.772 450.744 222.772 450.744L217.439 388.882L221.025 371.172L222.783 362.483L223.714 357.885L207.359 341.855C207.359 341.855 201.957 375.417 202.29 382.868C203.451 408.294 212.301 437.412 216.002 455.321C216.692 458.637 216.129 467.591 217.175 470.488C218.22 473.384 218.83 475.263 219.864 475.33C220.91 475.396 221.105 475.042 221.726 474.114C222.692 473.141 222.634 472.787 223.416 472.433C224.209 472.08 224.473 471.704 224.829 471.284C225.186 470.864 225.53 471.041 226.243 469.935C226.829 469.029 226.312 466.486 226.312 466.486C228.507 469.736 229.151 467.724 229.082 467.039C229.013 466.353 227.507 460.516 226.783 459.013Z",
    fill: "url(#paint50_linear_2197_5367)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M230.473 336.859C230.473 336.859 225.14 361.665 223.91 370.045C213.749 367.392 206.681 361.113 203.141 357.31C208.14 320.741 210.968 314.285 216.45 304.91C221.554 296.199 230.392 291.092 230.392 291.092L230.473 336.859Z",
    fill: "url(#paint51_linear_2197_5367)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M252.585 227.682C252.585 227.682 255.148 233.696 253.607 240.285L250.918 233.188L252.585 227.682Z",
    fill: "url(#paint52_linear_2197_5367)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M253.102 237.035C254.929 247.095 256.722 275.041 251.159 281.209C246.033 286.891 238.734 277.318 233.263 265.976C227.792 254.634 231.47 236.018 237.194 231.198C242.895 226.4 250.722 223.924 253.102 237.035Z",
    fill: "url(#paint53_linear_2197_5367)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M256.596 216.849C256.194 209.973 253.47 202.831 249.596 202.964C247.711 203.03 243.815 207.298 244.206 213.179C242.723 206.9 240.298 203.694 237.746 203.76C233.229 203.893 227.528 212.582 229.574 223.813C226.034 224.83 227.126 234.735 228.057 236.88C227.804 236.747 227.551 236.593 227.322 236.349C225.896 234.934 225.011 231.751 224.62 228.921C224.563 228.523 224.264 228.744 224.31 229.142C224.781 233.298 226.057 236.305 227.793 237.654C226.046 238.206 224.333 237.455 223.092 234.116C222.954 233.74 222.678 234.116 222.793 234.514C223.862 238.03 225.85 239.423 227.804 239.002C226.724 240.992 225.299 241.987 225.356 246.387C225.551 263.08 234.505 272.034 234.505 272.034L235.758 267.258C235.758 267.258 232.965 261.731 233.333 255.452C233.471 253.13 234.16 251.03 235.229 249.947C237.367 247.802 238.896 251.561 239.827 253.064L240.85 251.251L241.011 241.368C248.01 240.572 257.056 235.885 256.516 220.652C256.642 219.215 256.665 217.932 256.596 216.849ZM244.413 239.489C251.136 236.46 254.366 230.512 255.745 225.074C254.746 234.094 249.516 237.985 244.413 239.489Z",
    fill: "url(#paint54_linear_2197_5367)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M239.631 255.297C239.631 255.297 239.93 252.556 238.252 250.389C236.723 248.421 234.505 248.819 233.551 253.683C232.597 258.569 233.93 265.512 236.126 267.855C238.229 270.11 239.516 256.955 239.631 255.297Z",
    fill: "url(#paint55_linear_2197_5367)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M230.381 291.114L233.714 284.393C233.714 284.393 235.335 287.709 238.231 290.075C242.15 293.281 244.001 293.812 244.001 293.812L242.737 303.54C242.737 303.54 235.783 302.456 230.381 291.114Z",
    fill: "url(#paint56_linear_2197_5367)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M248.023 287.621C248.023 287.621 247.874 290.053 246.518 293.082C247.161 295.558 248.724 302.479 248.724 302.479C248.724 302.479 249.908 299.781 249.598 291.114L248.023 287.621Z",
    fill: "url(#paint57_linear_2197_5367)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M244.001 293.834L246.518 293.104L248.725 302.501L247.667 305.994L244.518 306.79L242.736 303.54L244.001 293.834Z",
    fill: "url(#paint58_linear_2197_5367)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M244.518 306.79C244.518 306.79 244.001 350.942 239.989 380.967C237.024 403.209 236.426 404.005 236.438 406.017C236.507 413.114 241.874 431.045 243.127 431.31C244.495 431.619 250.173 416.121 250.724 409.687C251.678 398.544 252.828 352.203 247.656 305.95L244.518 306.79Z",
    fill: "url(#paint59_linear_2197_5367)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M324.87 263.765L285.93 259.011L284.826 246.52L320.744 217.225L324.87 263.765Z",
    fill: "url(#paint60_linear_2197_5367)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M285.931 259.011L281.712 262.217L280.287 246.188L284.827 246.52L285.931 259.011Z",
    fill: "url(#paint61_linear_2197_5367)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M290.263 259.409C290.263 259.409 289.286 282.16 290.574 284.725C292.045 287.621 298.447 284.415 298.746 281.364C298.941 279.463 295.332 272.189 295.033 260.139L290.263 259.409Z",
    fill: "url(#paint62_linear_2197_5367)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M286.826 284.305C286.826 284.305 287.608 279.595 287.562 277.539C287.516 275.505 287.47 272.366 287.562 269.138C287.654 265.91 288.941 265.092 290.32 262.571C291.711 260.051 292.251 259.697 292.631 261.267C293.01 262.836 292.171 268.828 289.964 270.663L289.929 277.827L289.677 280.126L286.826 284.305Z",
    fill: "url(#paint63_linear_2197_5367)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M299.377 275.196C299.423 275.041 299.457 274.886 299.457 274.775C299.423 273.449 299.032 272.675 298.63 272.233C298.71 272.012 298.756 271.813 298.756 271.68C298.699 269.624 297.825 268.894 297.308 268.629C297.446 268.143 297.526 267.745 297.503 267.546C297.101 264.738 295.366 265.158 295.366 265.158L295.504 266.374C295.504 266.374 294.469 269.646 294.136 270.155C293.802 270.663 293.113 271.791 292.975 272.631C292.78 273.758 293.09 274.4 293.619 274.355C293.688 274.355 293.768 274.289 293.848 274.267C293.619 274.554 293.389 274.908 293.251 275.35C292.94 276.367 293.17 277.119 293.688 277.296C293.986 277.384 294.618 277.119 295.193 276.787C294.963 277.141 294.733 277.517 294.607 277.959C294.297 278.976 294.527 279.728 295.044 279.905C295.412 280.015 296.009 279.662 296.503 279.308C296.331 279.529 296.182 279.794 296.078 280.126C295.814 280.966 296.009 281.607 296.446 281.74C296.883 281.873 297.71 281.452 298.113 281.187C298.515 280.922 300.25 278.247 300.227 277.517C300.204 276.213 299.779 275.549 299.377 275.196Z",
    fill: "url(#paint64_linear_2197_5367)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M373.639 594.566H354.928V740.62H373.639V594.566Z",
    fill: "url(#paint65_linear_2197_5367)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M403.247 573.628H384.535V740.62H403.247V573.628Z",
    fill: "url(#paint66_linear_2197_5367)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M432.843 552.69H414.131V740.62H432.843V552.69Z",
    fill: "url(#paint67_linear_2197_5367)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M462.45 531.753H443.738V740.62H462.45V531.753Z",
    fill: "url(#paint68_linear_2197_5367)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M452.819 459.721L422.992 481.343L430.325 486.561C420.498 504.956 392.844 550.369 351.881 566.686C351.881 566.686 396.787 572.854 438.589 503.807L441.072 522.732L452.819 459.721Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M190.07 385.61H113.522C110.384 385.61 107.844 380.724 107.844 374.688V354.17C107.844 348.134 110.384 343.248 113.522 343.248H190.07C193.208 343.248 195.748 348.134 195.748 354.17V374.688C195.759 380.724 193.208 385.61 190.07 385.61Z",
    fill: "url(#paint69_linear_2197_5367)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M188.324 379.64H109.075C106.685 379.64 104.742 375.904 104.742 371.305V345.592C104.742 340.993 106.685 337.257 109.075 337.257H188.324C190.715 337.257 192.658 340.993 192.658 345.592V371.305C192.658 375.926 190.715 379.64 188.324 379.64Z",
    fill: "white",
    stroke: "url(#paint70_linear_2197_5367)",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M116.88 348.997L118.03 353.463C118.133 353.883 118.352 354.17 118.593 354.237L121.156 354.944C121.765 355.121 122.007 356.558 121.57 357.398L119.719 360.869C119.547 361.201 119.466 361.665 119.501 362.13L119.938 367.038C120.041 368.21 119.398 369.094 118.857 368.541L116.559 366.22C116.34 365.999 116.087 365.999 115.869 366.22L113.582 368.541C113.03 369.094 112.398 368.21 112.501 367.038L112.938 362.13C112.984 361.665 112.904 361.179 112.72 360.869L110.869 357.398C110.432 356.558 110.674 355.121 111.283 354.944L113.846 354.237C114.087 354.17 114.294 353.883 114.409 353.463L115.559 348.997C115.823 347.913 116.605 347.913 116.88 348.997Z",
    fill: "url(#paint71_linear_2197_5367)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M133.132 348.997L134.282 353.463C134.385 353.883 134.604 354.17 134.845 354.237L137.408 354.944C138.017 355.121 138.259 356.558 137.822 357.398L135.971 360.869C135.799 361.201 135.718 361.665 135.753 362.13L136.19 367.038C136.293 368.21 135.649 369.094 135.109 368.541L132.811 366.22C132.592 365.999 132.339 365.999 132.121 366.22L129.834 368.541C129.282 369.094 128.65 368.21 128.753 367.038L129.19 362.13C129.236 361.665 129.156 361.179 128.972 360.869L127.121 357.398C126.684 356.558 126.926 355.121 127.535 354.944L130.098 354.237C130.339 354.17 130.546 353.883 130.661 353.463L131.811 348.997C132.063 347.913 132.856 347.913 133.132 348.997Z",
    fill: "url(#paint72_linear_2197_5367)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M149.373 348.997L150.522 353.463C150.625 353.883 150.844 354.17 151.085 354.237L153.648 354.944C154.257 355.121 154.499 356.558 154.062 357.398L152.212 360.869C152.039 361.201 151.959 361.665 151.993 362.13L152.43 367.038C152.533 368.21 151.89 369.094 151.349 368.541L149.051 366.22C148.832 365.999 148.58 365.999 148.361 366.22L146.074 368.541C145.522 369.094 144.89 368.21 144.993 367.038L145.43 362.13C145.476 361.665 145.396 361.179 145.212 360.869L143.361 357.398C142.925 356.558 143.166 355.121 143.775 354.944L146.338 354.237C146.58 354.17 146.786 353.883 146.901 353.463L148.051 348.997C148.304 347.913 149.097 347.913 149.373 348.997Z",
    fill: "url(#paint73_linear_2197_5367)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M165.615 348.997L166.764 353.463C166.868 353.883 167.086 354.17 167.327 354.237L169.89 354.944C170.5 355.121 170.741 356.558 170.304 357.398L168.454 360.869C168.281 361.201 168.201 361.665 168.235 362.13L168.672 367.038C168.776 368.21 168.132 369.094 167.592 368.541L165.304 366.22C165.086 365.999 164.833 365.999 164.615 366.22L162.316 368.541C161.764 369.094 161.132 368.21 161.236 367.038L161.672 362.13C161.718 361.665 161.638 361.179 161.454 360.869L159.604 357.398C159.167 356.558 159.408 355.121 160.017 354.944L162.58 354.237C162.822 354.17 163.029 353.883 163.144 353.463L164.293 348.997C164.546 347.913 165.339 347.913 165.615 348.997Z",
    fill: "url(#paint74_linear_2197_5367)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M181.853 348.997L183.002 353.463C183.106 353.883 183.324 354.17 183.566 354.237L186.129 354.944C186.738 355.121 186.979 356.558 186.542 357.398L184.692 360.869C184.52 361.201 184.439 361.665 184.474 362.13L184.91 367.038C185.014 368.21 184.37 369.094 183.83 368.541L181.543 366.22C181.324 365.999 181.071 365.999 180.853 366.22L178.554 368.541C178.003 369.094 177.37 368.21 177.474 367.038L177.911 362.13C177.957 361.665 177.876 361.179 177.692 360.869L175.842 357.398C175.405 356.558 175.646 355.121 176.256 354.944L178.819 354.237C179.06 354.17 179.267 353.883 179.382 353.463L180.531 348.997C180.796 347.913 181.577 347.913 181.853 348.997Z",
    fill: "url(#paint75_linear_2197_5367)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M363.398 292.264C361.41 288.903 358.984 289.854 357.364 291.623C355.789 293.347 354.927 296 354.927 296C354.927 296 354.065 293.347 352.49 291.623C350.87 289.854 348.445 288.903 346.456 292.264C341.744 300.223 348.801 319.348 354.939 323.593C361.053 319.348 368.122 300.223 363.398 292.264Z",
    fill: "url(#paint76_linear_2197_5367)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M126.18 487.07C123.835 483.112 120.985 484.24 119.088 486.318C117.238 488.352 116.215 491.47 116.215 491.47C116.215 491.47 115.203 488.352 113.341 486.318C111.445 484.24 108.594 483.112 106.25 487.07C100.71 496.422 109.008 518.885 116.215 523.882C123.421 518.907 131.72 496.444 126.18 487.07Z",
    fill: "url(#paint77_linear_2197_5367)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M640.717 443.89C639.419 441.679 637.832 442.32 636.775 443.47C635.741 444.598 635.177 446.344 635.177 446.344C635.177 446.344 634.614 444.598 633.58 443.47C632.522 442.32 630.936 441.679 629.637 443.89C626.557 449.108 631.178 461.6 635.177 464.386C639.177 461.622 643.798 449.108 640.717 443.89Z",
    fill: "url(#paint78_linear_2197_5367)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6414 162.305C48.6414 164.737 47.6184 166.683 46.3656 166.683C45.1013 166.683 44.0898 164.715 44.0898 162.305C44.0898 159.873 45.1128 157.927 46.3656 157.927C47.6184 157.905 48.6414 159.873 48.6414 162.305Z",
    fill: "url(#paint79_linear_2197_5367)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M191.947 22.6842C191.947 23.7013 191.522 24.5193 190.993 24.5193C190.464 24.5193 190.039 23.7013 190.039 22.6842C190.039 21.6672 190.464 20.8491 190.993 20.8491C191.522 20.8491 191.947 21.6672 191.947 22.6842Z",
    fill: "url(#paint80_linear_2197_5367)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.2076 585.899C18.6232 585.899 19.7707 583.691 19.7707 580.968C19.7707 578.245 18.6232 576.038 17.2076 576.038C15.7921 576.038 14.6445 578.245 14.6445 580.968C14.6445 583.691 15.7921 585.899 17.2076 585.899Z",
    fill: "url(#paint81_linear_2197_5367)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M270.07 95.3357C270.07 99.3596 268.369 102.632 266.277 102.632C264.185 102.632 262.484 99.3596 262.484 95.3357C262.484 91.3118 264.185 88.0396 266.277 88.0396C268.369 88.0396 270.07 91.3118 270.07 95.3357Z",
    fill: "url(#paint82_linear_2197_5367)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.583 315.479C114.583 317.248 113.836 318.685 112.917 318.685C111.997 318.685 111.25 317.248 111.25 315.479C111.25 313.71 111.997 312.273 112.917 312.273C113.836 312.273 114.583 313.71 114.583 315.479Z",
    fill: "url(#paint83_linear_2197_5367)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M467.337 165.312C468.257 165.312 469.003 163.877 469.003 162.106C469.003 160.335 468.257 158.9 467.337 158.9C466.416 158.9 465.67 160.335 465.67 162.106C465.67 163.877 466.416 165.312 467.337 165.312Z",
    fill: "url(#paint84_linear_2197_5367)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M603.021 598.7C604.201 598.7 605.159 596.859 605.159 594.588C605.159 592.317 604.201 590.475 603.021 590.475C601.84 590.475 600.883 592.317 600.883 594.588C600.883 596.859 601.84 598.7 603.021 598.7Z",
    fill: "url(#paint85_linear_2197_5367)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M587.502 114.438C587.502 117.357 586.272 119.7 584.767 119.7C583.25 119.7 582.031 117.335 582.031 114.438C582.031 111.52 583.261 109.176 584.767 109.176C586.284 109.176 587.502 111.52 587.502 114.438Z",
    fill: "url(#paint86_linear_2197_5367)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M147.798 102.654C147.798 106.169 146.315 109.021 144.488 109.021C142.66 109.021 141.178 106.169 141.178 102.654C141.178 99.1385 142.66 96.2863 144.488 96.2863C146.315 96.2863 147.798 99.1385 147.798 102.654Z",
    fill: "url(#paint87_linear_2197_5367)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M328.169 95.3357C328.169 98.851 326.687 101.703 324.859 101.703C323.032 101.703 321.549 98.851 321.549 95.3357C321.549 91.8203 323.032 88.9681 324.859 88.9681C326.698 88.9902 328.169 91.8424 328.169 95.3357Z",
    fill: "url(#paint88_linear_2197_5367)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M584.767 225.007C584.767 228.523 583.284 231.375 581.457 231.375C579.629 231.375 578.146 228.523 578.146 225.007C578.146 221.492 579.629 218.64 581.457 218.64C583.284 218.64 584.767 221.492 584.767 225.007Z",
    fill: "url(#paint89_linear_2197_5367)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M668.429 634.606C668.429 637.391 667.256 639.647 665.808 639.647C664.36 639.647 663.188 637.391 663.188 634.606C663.188 631.82 664.36 629.565 665.808 629.565C667.256 629.565 668.429 631.82 668.429 634.606Z",
    fill: "url(#paint90_linear_2197_5367)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M311.437 311.986C311.437 313.909 310.621 315.479 309.621 315.479C308.621 315.479 307.805 313.909 307.805 311.986C307.805 310.062 308.621 308.492 309.621 308.492C310.621 308.47 311.437 310.04 311.437 311.986Z",
    fill: "url(#paint91_linear_2197_5367)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M234.061 13.0003C235.927 13.0003 237.44 10.0901 237.44 6.50016C237.44 2.91023 235.927 0 234.061 0C232.195 0 230.682 2.91023 230.682 6.50016C230.682 10.0901 232.195 13.0003 234.061 13.0003Z",
    fill: "url(#paint92_linear_2197_5367)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M520.413 57.3296C520.413 62.1716 518.367 66.107 515.85 66.107C513.333 66.107 511.287 62.1716 511.287 57.3296C511.287 52.4877 513.333 48.5522 515.85 48.5522C518.379 48.5522 520.413 52.4877 520.413 57.3296Z",
    fill: "url(#paint93_linear_2197_5367)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M701.889 542.144C704.409 542.144 706.452 538.215 706.452 533.367C706.452 528.519 704.409 524.589 701.889 524.589C699.369 524.589 697.326 528.519 697.326 533.367C697.326 538.215 699.369 542.144 701.889 542.144Z",
    fill: "url(#paint94_linear_2197_5367)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M612.755 676.282C613.834 676.282 614.709 674.599 614.709 672.523C614.709 670.448 613.834 668.765 612.755 668.765C611.676 668.765 610.801 670.448 610.801 672.523C610.801 674.599 611.676 676.282 612.755 676.282Z",
    fill: "url(#paint95_linear_2197_5367)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M486.001 573.628C486.001 578.47 483.955 582.405 481.438 582.405C478.921 582.405 476.875 578.47 476.875 573.628C476.875 568.786 478.921 564.851 481.438 564.851C483.967 564.851 486.001 568.786 486.001 573.628Z",
    fill: "url(#paint96_linear_2197_5367)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M116.81 440.596C118.41 440.596 119.707 438.101 119.707 435.024C119.707 431.947 118.41 429.453 116.81 429.453C115.211 429.453 113.914 431.947 113.914 435.024C113.914 438.101 115.211 440.596 116.81 440.596Z",
    fill: "url(#paint97_linear_2197_5367)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M674.834 415.966H673.719V413.821C673.719 412.981 673.362 412.296 672.926 412.296C672.489 412.296 672.133 412.981 672.133 413.821V415.966H671.018C670.581 415.966 670.225 416.651 670.225 417.492C670.225 418.332 670.581 419.017 671.018 419.017H672.133V421.162C672.133 422.002 672.489 422.687 672.926 422.687C673.362 422.687 673.719 422.002 673.719 421.162V419.017H674.834C675.27 419.017 675.627 418.332 675.627 417.492C675.627 416.651 675.27 415.966 674.834 415.966Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M478.37 660.385H476.968V657.688C476.968 656.627 476.52 655.742 475.956 655.742C475.393 655.742 474.945 656.605 474.945 657.688V660.385H473.543C472.991 660.385 472.531 661.248 472.531 662.331C472.531 663.392 472.98 664.277 473.543 664.277H474.945V666.974C474.945 668.035 475.393 668.919 475.956 668.919C476.52 668.919 476.968 668.057 476.968 666.974V664.277H478.37C478.922 664.277 479.381 663.414 479.381 662.331C479.381 661.248 478.922 660.385 478.37 660.385Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M293.114 157.839H290.861V153.505C290.861 151.781 290.137 150.41 289.252 150.41C288.356 150.41 287.643 151.803 287.643 153.505V157.839H285.39C284.494 157.839 283.781 159.232 283.781 160.934C283.781 162.637 284.505 164.03 285.39 164.03H287.643V168.363C287.643 170.087 288.367 171.458 289.252 171.458C290.149 171.458 290.861 170.065 290.861 168.363V164.03H293.114C294.011 164.03 294.723 162.637 294.723 160.934C294.723 159.232 294.011 157.839 293.114 157.839Z",
    fill: "url(#paint98_linear_2197_5367)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8505 320.387H57.5977V316.054C57.5977 314.329 56.8736 312.958 55.9886 312.958C55.0921 312.958 54.3795 314.351 54.3795 316.054V320.387H52.1267C51.2302 320.387 50.5176 321.78 50.5176 323.482C50.5176 325.185 51.2417 326.578 52.1267 326.578H54.3795V330.911C54.3795 332.636 55.1036 334.006 55.9886 334.006C56.8851 334.006 57.5977 332.614 57.5977 330.911V326.578H59.8505C60.747 326.578 61.4596 325.185 61.4596 323.482C61.4596 321.78 60.747 320.387 59.8505 320.387Z",
    fill: "url(#paint99_linear_2197_5367)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M433.464 10.723H431.211V6.3896C431.211 4.66507 430.487 3.29428 429.602 3.29428C428.705 3.29428 427.993 4.68718 427.993 6.3896V10.723H425.74C424.843 10.723 424.131 12.1159 424.131 13.8184C424.131 15.5429 424.855 16.9137 425.74 16.9137H427.993V21.2471C427.993 22.9716 428.717 24.3424 429.602 24.3424C430.498 24.3424 431.211 22.9495 431.211 21.2471V16.9137H433.464C434.36 16.9137 435.073 15.5208 435.073 13.8184C435.073 12.1159 434.349 10.723 433.464 10.723Z",
    fill: "url(#paint100_linear_2197_5367)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M621.604 362.771H620.053V359.786C620.053 358.592 619.558 357.641 618.938 357.641C618.317 357.641 617.823 358.592 617.823 359.786V362.771H616.271C615.65 362.771 615.156 363.722 615.156 364.915C615.156 366.109 615.65 367.06 616.271 367.06H617.823V370.045C617.823 371.239 618.317 372.189 618.938 372.189C619.558 372.189 620.053 371.239 620.053 370.045V367.06H621.604C622.225 367.06 622.719 366.109 622.719 364.915C622.719 363.744 622.213 362.771 621.604 362.771Z",
    fill: "url(#paint101_linear_2197_5367)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M691.347 227.594H622.062V292.33H691.347V227.594Z",
    fill: "url(#paint102_linear_2197_5367)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M688.473 240.616V279.264C686.301 279.264 684.542 282.646 684.542 286.825H628.878C628.878 282.646 627.12 279.264 624.947 279.264V240.616C627.12 240.616 628.878 237.234 628.878 233.055H684.542C684.542 237.234 686.301 240.616 688.473 240.616Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M657.302 284.791C664.431 284.791 670.209 273.675 670.209 259.962C670.209 246.25 664.431 235.133 657.302 235.133C650.173 235.133 644.395 246.25 644.395 259.962C644.395 273.675 650.173 284.791 657.302 284.791Z",
    fill: "url(#paint103_linear_2197_5367)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M658.267 257.795C656.589 256.447 656.302 255.761 656.302 254.7C656.302 253.727 656.67 252.71 657.716 252.71C658.808 252.71 659.474 253.44 659.796 253.794L660.382 254.435L661.256 249.969L660.83 249.504C660.187 248.775 659.486 248.355 658.681 248.178V244.596H656.371V248.443C654.635 249.328 653.543 251.87 653.543 255.142C653.543 259.233 655.29 261.112 656.992 262.394C658.532 263.588 658.75 264.671 658.75 265.666C658.75 267.126 658.083 268.098 657.095 268.098C656.267 268.098 655.382 267.59 654.716 266.728L654.107 265.932L653.268 270.464L653.624 270.951C654.268 271.835 655.256 272.476 656.244 272.675V276.389H658.578V272.432C660.371 271.503 661.543 268.784 661.543 265.423C661.52 260.935 659.784 258.989 658.267 257.795Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M686.069 217.446H616.785V282.182H686.069V217.446Z",
    fill: "url(#paint104_linear_2197_5367)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M684.427 214.262H615.143V278.998H684.427V214.262Z",
    fill: "url(#paint105_linear_2197_5367)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M681.553 227.307V265.954C679.381 265.954 677.622 269.337 677.622 273.515H621.958C621.958 269.337 620.2 265.954 618.027 265.954V227.307C620.2 227.307 621.958 223.924 621.958 219.745H677.622C677.611 223.924 679.369 227.307 681.553 227.307Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M650.382 271.459C657.511 271.459 663.29 260.343 663.29 246.63C663.29 232.918 657.511 221.801 650.382 221.801C643.253 221.801 637.475 232.918 637.475 246.63C637.475 260.343 643.253 271.459 650.382 271.459Z",
    fill: "url(#paint106_linear_2197_5367)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M651.338 244.486C649.66 243.137 649.372 242.452 649.372 241.39C649.372 240.417 649.74 239.4 650.786 239.4C651.878 239.4 652.544 240.13 652.866 240.484L653.452 241.125L654.326 236.659L653.901 236.195C653.257 235.465 652.556 235.045 651.751 234.868V231.286H649.441V235.133C647.706 236.018 646.614 238.56 646.614 241.832C646.614 245.923 648.361 247.802 650.062 249.084C651.602 250.278 651.82 251.362 651.82 252.357C651.82 253.816 651.154 254.789 650.165 254.789C649.338 254.789 648.453 254.28 647.786 253.418L647.177 252.622L646.338 257.154L646.694 257.641C647.338 258.525 648.326 259.166 649.315 259.365V263.08H651.648V259.122C653.441 258.193 654.613 255.474 654.613 252.113C654.602 247.603 652.855 245.657 651.338 244.486Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M464.84 414.153C473.365 414.153 480.276 400.859 480.276 384.46C480.276 368.061 473.365 354.767 464.84 354.767C456.315 354.767 449.404 368.061 449.404 384.46C449.404 400.859 456.315 414.153 464.84 414.153Z",
    fill: "url(#paint107_linear_2197_5367)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M465.99 381.873C463.979 380.259 463.634 379.441 463.634 378.181C463.634 377.031 464.082 375.793 465.324 375.793C466.622 375.793 467.427 376.656 467.806 377.076L468.507 377.849L469.553 372.521L469.047 371.968C468.277 371.106 467.438 370.575 466.473 370.376V366.109H463.714V370.708C461.646 371.769 460.335 374.82 460.335 378.712C460.335 383.62 462.427 385.853 464.462 387.379C466.312 388.816 466.565 390.098 466.565 391.27C466.565 392.994 465.772 394.166 464.588 394.166C463.599 394.166 462.542 393.547 461.749 392.53L461.013 391.601L460.002 397.018L460.427 397.593C461.197 398.654 462.37 399.406 463.565 399.649V404.071H466.346V399.34C468.484 398.234 469.887 394.984 469.887 390.96C469.887 385.632 467.806 383.31 465.99 381.873Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8482 241.589H84.2508C82.7796 241.589 81.5957 239.29 81.5957 236.482V200.2C81.5957 197.37 82.7911 195.093 84.2508 195.093H88.8482C90.3194 195.093 91.5033 197.393 91.5033 200.2V236.482C91.5033 239.312 90.3194 241.589 88.8482 241.589Z",
    fill: "url(#paint108_linear_2197_5367)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M118.972 222.951C118.409 229.23 115.443 230.601 115.443 230.601C115.443 230.601 117.397 230.955 116.914 234.603C116.432 238.251 114.777 241.611 113.282 241.611H101.168C99.1681 241.611 97.1797 240.86 95.3637 239.29C95.2488 239.179 95.1338 239.091 95.0189 239.002C94.2718 238.383 93.7891 236.946 93.7891 235.377V201.571C93.7891 200.001 93.9959 198.454 94.3752 197.061C95.2143 194.032 96.651 188.372 96.651 185.321C96.651 181.032 93.2603 167.302 95.6166 164.45C97.9153 161.664 100.915 165.445 102.892 172.298C104.444 177.715 103.34 189.433 104.455 191.578H116.19C116.19 191.578 119.374 191.357 119.156 197.017C118.972 201.881 117.593 204.644 117.593 204.644C117.593 204.644 119.673 204.357 119.592 209.575C119.523 214.549 117.512 217.999 117.512 217.999C117.512 217.999 119.374 218.573 118.972 222.951Z",
    fill: "url(#paint109_linear_2197_5367)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "scalelableDesign",
    d: "M592.446 548.158H591.458C589.987 548.158 588.803 545.859 588.803 543.051V523.683C588.803 520.853 589.998 518.576 591.458 518.576H592.446C593.917 518.576 595.101 520.875 595.101 523.683V543.051C595.101 545.859 593.917 548.158 592.446 548.158Z",
    fill: "url(#paint110_linear_2197_5367)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "scalelableDesign",
    d: "M612.583 536.285C612.227 540.287 610.342 541.149 610.342 541.149C610.342 541.149 611.583 541.37 611.284 543.692C610.974 546.013 609.928 548.158 608.974 548.158H601.262C599.986 548.158 598.722 547.694 597.572 546.677C597.492 546.61 597.423 546.544 597.354 546.5C596.871 546.102 596.572 545.195 596.572 544.2V522.688C596.572 521.693 596.699 520.698 596.94 519.814C597.469 517.89 598.388 514.286 598.388 512.341C598.388 509.621 596.239 500.888 597.733 499.075C599.193 497.306 601.101 499.716 602.365 504.072C603.354 507.521 602.652 514.972 603.354 516.343H610.824C610.824 516.343 612.847 516.21 612.709 519.792C612.595 522.887 611.721 524.656 611.721 524.656C611.721 524.656 613.043 524.479 612.997 527.795C612.951 530.957 611.675 533.168 611.675 533.168C611.675 533.168 612.824 533.522 612.583 536.285Z",
    fill: "url(#paint111_linear_2197_5367)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M152.715 609.291H73.041V740.62H152.715V609.291Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M154.555 591.603H71.1914V615.99H154.555V591.603Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M152.715 615.99H73.041V621.782H152.715V615.99Z",
    fill: "url(#paint112_linear_2197_5367)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M117.074 591.603H108.684V615.99H117.074V591.603Z",
    fill: "url(#paint113_linear_2197_5367)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M116.155 615.99H109.592V740.62H116.155V615.99Z",
    fill: "url(#paint114_linear_2197_5367)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M96.168 591.603V578.315L112.834 591.603H96.168Z",
    fill: "url(#paint115_linear_2197_5367)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M129.592 591.603V578.315L112.926 591.603H129.592Z",
    fill: "url(#paint116_linear_2197_5367)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M188.266 709.402H88.627V740.62H188.266V709.402Z",
    fill: "url(#paint117_linear_2197_5367)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M188.266 709.402H88.627V713.824H188.266V709.402Z",
    fill: "url(#paint118_linear_2197_5367)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M189.529 698.612H87.3848V709.402H189.529V698.612Z",
    fill: "url(#paint119_linear_2197_5367)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M142.9 698.612H134.016V709.402H142.9V698.612Z",
    fill: "url(#paint120_linear_2197_5367)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M141.934 709.402H134.969V740.62H141.934V709.402Z",
    fill: "url(#paint121_linear_2197_5367)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M138.451 698.612L155.117 685.325V698.612H138.451Z",
    fill: "url(#paint122_linear_2197_5367)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M138.451 698.612L121.785 685.325V698.612H138.451Z",
    fill: "url(#paint123_linear_2197_5367)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M430.292 280.867C448.604 265.944 457.16 225.289 449.402 190.063C441.644 154.837 420.509 138.378 402.197 153.302C383.884 168.226 375.328 208.88 383.086 244.107C390.845 279.333 411.979 295.791 430.292 280.867Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M416.231 145.767C395.795 145.767 379.164 177.76 379.164 217.07C379.164 256.381 395.795 288.373 416.231 288.373C436.667 288.373 453.299 256.381 453.299 217.07C453.299 177.76 436.667 145.767 416.231 145.767ZM382.348 233.586H392.577C393.313 242.673 394.646 251.096 396.451 258.481H388.715C385.761 251.229 383.555 242.783 382.348 233.586ZM450.126 200.576H439.897C439.161 191.489 437.828 183.066 436.023 175.681H443.759C446.713 182.933 448.919 191.379 450.126 200.576ZM437.77 200.576H426.851C426.541 191.799 425.989 183.287 425.196 175.681H433.713C435.598 182.933 437 191.379 437.77 200.576ZM438.449 217.07C438.449 221.315 438.311 225.494 438.058 229.518H426.978C427.081 225.383 427.139 221.204 427.139 217.07C427.139 212.936 427.081 208.757 426.978 204.622H438.058C438.311 208.668 438.449 212.825 438.449 217.07ZM407.588 229.518C407.485 225.516 407.427 221.359 407.427 217.07C407.427 212.759 407.485 208.624 407.588 204.622H424.886C424.989 208.624 425.047 212.781 425.047 217.07C425.047 221.381 424.989 225.516 424.886 229.518H407.588ZM424.76 233.586C424.438 242.96 423.84 251.362 423.082 258.481H409.393C408.622 251.34 408.036 242.96 407.703 233.586H424.76ZM394.014 217.07C394.014 212.825 394.152 208.646 394.405 204.622H405.485C405.381 208.757 405.324 212.936 405.324 217.07C405.324 221.204 405.381 225.383 405.485 229.518H394.405C394.152 225.494 394.014 221.337 394.014 217.07ZM407.703 200.576C408.025 191.202 408.622 182.8 409.393 175.681H423.082C423.852 182.823 424.438 191.202 424.76 200.576H407.703ZM424.748 171.613C423.691 162.902 422.3 155.694 420.587 151.118C425.288 153.97 429.461 161.31 432.587 171.613H424.748ZM422.599 171.613H409.864C411.588 157.905 413.979 149.813 416.231 149.813C418.484 149.813 420.875 157.927 422.599 171.613ZM407.714 171.613H399.876C403.002 161.31 407.174 153.97 411.875 151.118C410.163 155.694 408.772 162.902 407.714 171.613ZM407.266 175.659C406.473 183.265 405.921 191.777 405.611 200.554H394.692C395.462 191.357 396.864 182.911 398.738 175.659H407.266ZM392.577 200.576H382.348C383.555 191.379 385.761 182.933 388.727 175.681H396.462C394.646 183.044 393.313 191.467 392.577 200.576ZM392.29 204.622C392.048 208.668 391.911 212.825 391.911 217.07C391.911 221.315 392.048 225.472 392.29 229.518H381.888C381.497 225.472 381.279 221.315 381.279 217.07C381.279 212.825 381.497 208.646 381.888 204.622H392.29ZM394.692 233.586H405.611C405.921 242.363 406.473 250.875 407.266 258.481H398.749C396.864 251.229 395.462 242.783 394.692 233.586ZM407.714 262.527C408.772 271.238 410.163 278.446 411.875 283.022C407.174 280.17 403.002 272.83 399.876 262.527H407.714ZM409.864 262.527H422.599C420.875 276.235 418.484 284.327 416.231 284.327C413.979 284.327 411.588 276.235 409.864 262.527ZM424.748 262.527H432.587C429.461 272.83 425.288 280.17 420.587 283.022C422.311 278.446 423.702 271.238 424.748 262.527ZM425.208 258.481C426.001 250.875 426.553 242.363 426.863 233.586H437.782C437.012 242.783 435.61 251.229 433.736 258.481H425.208ZM439.897 233.586H450.126C448.919 242.783 446.713 251.229 443.747 258.481H436.012C437.816 251.096 439.15 242.673 439.897 233.586ZM440.184 229.518C440.426 225.472 440.563 221.315 440.563 217.07C440.563 212.825 440.426 208.668 440.184 204.622H450.586C450.977 208.668 451.195 212.825 451.195 217.07C451.195 221.315 450.977 225.494 450.586 229.518H440.184ZM441.966 171.613H434.955C432.771 163.875 430.035 157.529 426.932 153.041C432.759 156.667 437.92 163.145 441.966 171.613ZM405.531 153.063C402.427 157.529 399.692 163.897 397.508 171.635H390.497C394.543 163.145 399.715 156.667 405.531 153.063ZM390.497 262.527H397.508C399.692 270.265 402.427 276.611 405.531 281.099C399.715 277.473 394.543 271.017 390.497 262.527ZM426.932 281.099C430.035 276.633 432.771 270.265 434.955 262.527H441.966C437.92 271.017 432.759 277.473 426.932 281.099Z",
    fill: "url(#paint124_linear_2197_5367)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2197_5367",
    x1: 363.444,
    y1: 738.342,
    x2: 363.444,
    y2: -40.1059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C90D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2197_5367",
    x1: 323.236,
    y1: 420.428,
    x2: 375.532,
    y2: 420.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C90D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2197_5367",
    x1: 328.823,
    y1: 384.978,
    x2: 388.604,
    y2: 412.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2197_5367",
    x1: 361.509,
    y1: 370.08,
    x2: 386.272,
    y2: 382.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B56BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2197_5367",
    x1: 355.143,
    y1: 173.445,
    x2: 322.227,
    y2: 178.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AA0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2197_5367",
    x1: 354.506,
    y1: 169.467,
    x2: 321.59,
    y2: 174.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AA0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2197_5367",
    x1: 353.87,
    y1: 165.49,
    x2: 320.954,
    y2: 170.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AA0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2197_5367",
    x1: 16.0915,
    y1: 742.836,
    x2: 735.621,
    y2: 742.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2197_5367",
    x1: 144.651,
    y1: 759.786,
    x2: 408.07,
    y2: 759.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2197_5367",
    x1: 78.2921,
    y1: 759.786,
    x2: 797.821,
    y2: 759.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2197_5367",
    x1: 14.9397,
    y1: 759.786,
    x2: 432.449,
    y2: 759.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2197_5367",
    x1: 399.619,
    y1: 759.786,
    x2: 651.773,
    y2: 759.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2197_5367",
    x1: 295.242,
    y1: 585.085,
    x2: 346.021,
    y2: 585.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2197_5367",
    x1: -13.4952,
    y1: 554.368,
    x2: 106.788,
    y2: 604.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464CAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2197_5367",
    x1: 120.804,
    y1: 662.309,
    x2: 162.012,
    y2: 680.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464CAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2197_5367",
    x1: 129.105,
    y1: 487.947,
    x2: 412.86,
    y2: 652.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464CAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2197_5367",
    x1: 649.851,
    y1: 644.081,
    x2: 649.851,
    y2: 747.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464CAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2197_5367",
    x1: 192.471,
    y1: 116.821,
    x2: 382.792,
    y2: 669.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2197_5367",
    x1: 147.958,
    y1: 158.299,
    x2: 522.24,
    y2: 493.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9109,
    stopColor: "#6074CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2197_5367",
    x1: 163.047,
    y1: 77.4853,
    x2: 395.699,
    y2: 208.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2197_5367",
    x1: 150.119,
    y1: 100.391,
    x2: 382.772,
    y2: 231.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2197_5367",
    x1: 131.233,
    y1: 288.375,
    x2: 142.373,
    y2: 288.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B56BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2197_5367",
    x1: 125.238,
    y1: 242.524,
    x2: 206.194,
    y2: 339.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2197_5367",
    x1: 182.128,
    y1: 285.787,
    x2: 100.314,
    y2: 248.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B56BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2197_5367",
    x1: 240.127,
    y1: 586.314,
    x2: 124.029,
    y2: 556.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2197_5367",
    x1: 239.195,
    y1: 589.918,
    x2: 123.098,
    y2: 559.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B56BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2197_5367",
    x1: 264.112,
    y1: 239.02,
    x2: 276.818,
    y2: 240.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2197_5367",
    x1: 263.875,
    y1: 240.572,
    x2: 276.581,
    y2: 242.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2197_5367",
    x1: 263.638,
    y1: 242.124,
    x2: 276.344,
    y2: 244.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2197_5367",
    x1: 146.325,
    y1: 261.369,
    x2: 387.879,
    y2: 374.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B56BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2197_5367",
    x1: 202.586,
    y1: 534.034,
    x2: 346.886,
    y2: 614.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B56BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2197_5367",
    x1: 247.894,
    y1: 284.309,
    x2: 163.981,
    y2: 268.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2197_5367",
    x1: 245.655,
    y1: 296.535,
    x2: 161.742,
    y2: 281.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2197_5367",
    x1: 245.671,
    y1: 296.455,
    x2: 161.758,
    y2: 281.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2197_5367",
    x1: 247.341,
    y1: 558.423,
    x2: 131.242,
    y2: 528.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2197_5367",
    x1: 248.099,
    y1: 555.493,
    x2: 132,
    y2: 525.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2197_5367",
    x1: 245.574,
    y1: 565.262,
    x2: 129.475,
    y2: 535.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2197_5367",
    x1: 238.275,
    y1: 593.492,
    x2: 122.177,
    y2: 563.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2197_5367",
    x1: 259.55,
    y1: 511.187,
    x2: 143.451,
    y2: 481.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2197_5367",
    x1: 247.649,
    y1: 427.786,
    x2: 255.06,
    y2: 525.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2197_5367",
    x1: 222.791,
    y1: 429.666,
    x2: 230.203,
    y2: 527.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2197_5367",
    x1: 266.468,
    y1: 279.408,
    x2: 320.885,
    y2: 321.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2197_5367",
    x1: 263.764,
    y1: 300.466,
    x2: 249.13,
    y2: 440.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2197_5367",
    x1: 257.898,
    y1: 333.674,
    x2: 276.678,
    y2: 342.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2197_5367",
    x1: 236.819,
    y1: 297.146,
    x2: 222.05,
    y2: 438.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2197_5367",
    x1: 239.286,
    y1: 239.26,
    x2: 242.185,
    y2: 296.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2197_5367",
    x1: 238.233,
    y1: 280.658,
    x2: 248.028,
    y2: 280.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2197_5367",
    x1: 216.138,
    y1: 372.039,
    x2: 239.542,
    y2: 383.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2197_5367",
    x1: 250.73,
    y1: 469.368,
    x2: 173.462,
    y2: 452.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2197_5367",
    x1: 183.765,
    y1: 405.182,
    x2: 250.706,
    y2: 425.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2197_5367",
    x1: 202.261,
    y1: 408.583,
    x2: 229.091,
    y2: 408.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2197_5367",
    x1: 218.271,
    y1: 295.205,
    x2: 203.503,
    y2: 436.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2197_5367",
    x1: 250.356,
    y1: 199.501,
    x2: 265.868,
    y2: 267.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C176F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2197_5367",
    x1: 240.805,
    y1: 230.554,
    x2: 262.624,
    y2: 302.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2197_5367",
    x1: 238.235,
    y1: 202.279,
    x2: 253.747,
    y2: 269.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C176F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2197_5367",
    x1: 234.484,
    y1: 232.472,
    x2: 256.303,
    y2: 304.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2197_5367",
    x1: 237.409,
    y1: 284.791,
    x2: 235.525,
    y2: 302.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2197_5367",
    x1: 246.035,
    y1: 290.985,
    x2: 253.3,
    y2: 294.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2197_5367",
    x1: 242.825,
    y1: 295.255,
    x2: 251.7,
    y2: 299.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B56BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2197_5367",
    x1: 227.178,
    y1: 337.069,
    x2: 281.803,
    y2: 362.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B56BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2197_5367",
    x1: 302.261,
    y1: 227.28,
    x2: 314.882,
    y2: 261.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2197_5367",
    x1: 282.217,
    y1: 245.191,
    x2: 289.304,
    y2: 261.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2197_5367",
    x1: 288.622,
    y1: 262.781,
    x2: 305.52,
    y2: 273.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B56BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2197_5367",
    x1: 289.021,
    y1: 268.097,
    x2: 330.337,
    y2: 341.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2197_5367",
    x1: 295.661,
    y1: 270.084,
    x2: 330.156,
    y2: 331.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2197_5367",
    x1: 364.285,
    y1: 531.149,
    x2: 364.285,
    y2: 728.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2197_5367",
    x1: 393.888,
    y1: 531.149,
    x2: 393.888,
    y2: 728.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2197_5367",
    x1: 423.491,
    y1: 531.149,
    x2: 423.491,
    y2: 728.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2197_5367",
    x1: 453.095,
    y1: 507.811,
    x2: 453.095,
    y2: 727.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2197_5367",
    x1: 107.849,
    y1: 364.434,
    x2: 195.754,
    y2: 364.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C90D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2197_5367",
    x1: 104.174,
    y1: 358.466,
    x2: 193.228,
    y2: 358.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2197_5367",
    x1: 111.022,
    y1: 357.32,
    x2: 186.159,
    y2: 363.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2197_5367",
    x1: 111.432,
    y1: 352.415,
    x2: 186.57,
    y2: 358.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2197_5367",
    x1: 111.843,
    y1: 347.511,
    x2: 186.98,
    y2: 353.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2197_5367",
    x1: 112.255,
    y1: 342.606,
    x2: 187.392,
    y2: 348.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2197_5367",
    x1: 112.663,
    y1: 337.701,
    x2: 187.8,
    y2: 343.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2197_5367",
    x1: 346.393,
    y1: 287.472,
    x2: 371.84,
    y2: 299.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED716A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED534E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2197_5367",
    x1: 199.677,
    y1: 638.993,
    x2: 225.125,
    y2: 650.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED716A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED534E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2197_5367",
    x1: 625.991,
    y1: 435.731,
    x2: 651.695,
    y2: 446.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED716A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED534E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2197_5367",
    x1: 52.9109,
    y1: 170.702,
    x2: 418.244,
    y2: 297.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2197_5367",
    x1: 182.72,
    y1: 12.0622,
    x2: 335.297,
    y2: 64.9769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2197_5367",
    x1: -10.256,
    y1: 545.735,
    x2: 241.379,
    y2: 633.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2197_5367",
    x1: 106.433,
    y1: -109.777,
    x2: 836.856,
    y2: 143.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2197_5367",
    x1: 111.242,
    y1: 315.48,
    x2: 114.58,
    y2: 315.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2197_5367",
    x1: 465.663,
    y1: 162.096,
    x2: 469.001,
    y2: 162.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2197_5367",
    x1: 158.338,
    y1: 23.9303,
    x2: 888.753,
    y2: 277.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2197_5367",
    x1: 398.895,
    y1: -124.09,
    x2: 668.274,
    y2: -30.6678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2197_5367",
    x1: 32.1377,
    y1: -41.5328,
    x2: 762.555,
    y2: 211.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2197_5367",
    x1: 212.515,
    y1: -48.8366,
    x2: 942.938,
    y2: 204.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2197_5367",
    x1: 469.11,
    y1: 80.8202,
    x2: 1199.53,
    y2: 334.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2197_5367",
    x1: 576.728,
    y1: 520.29,
    x2: 1155.87,
    y2: 721.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2197_5367",
    x1: 247.759,
    y1: 232.601,
    x2: 649.897,
    y2: 372.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2197_5367",
    x1: 55.8495,
    y1: -222.185,
    x2: 388.438,
    y2: -106.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2197_5367",
    x1: 206.947,
    y1: -339.085,
    x2: 937.365,
    y2: -85.7713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2197_5367",
    x1: 239.828,
    y1: -59.5805,
    x2: 970.245,
    y2: 193.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2197_5367",
    x1: 49.7692,
    y1: -49.9473,
    x2: 780.175,
    y2: 203.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2197_5367",
    x1: 74.3567,
    y1: 51.2213,
    x2: 804.774,
    y2: 304.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2197_5367",
    x1: -20.1999,
    y1: 259.206,
    x2: 710.213,
    y2: 512.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2197_5367",
    x1: 283.777,
    y1: 160.945,
    x2: 294.729,
    y2: 160.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2197_5367",
    x1: 52.1245,
    y1: 316.046,
    x2: 64.4156,
    y2: 322.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2197_5367",
    x1: 424.122,
    y1: 13.8214,
    x2: 435.074,
    y2: 13.8214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2197_5367",
    x1: 505.431,
    y1: 219.275,
    x2: 1243.3,
    y2: 475.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2197_5367",
    x1: 620.713,
    y1: 226.621,
    x2: 710.647,
    y2: 249.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2197_5367",
    x1: 637.744,
    y1: 238.608,
    x2: 681.888,
    y2: 251.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2197_5367",
    x1: 615.439,
    y1: 216.479,
    x2: 705.372,
    y2: 238.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C90D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2197_5367",
    x1: 613.788,
    y1: 213.301,
    x2: 703.721,
    y2: 235.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2197_5367",
    x1: 630.818,
    y1: 225.288,
    x2: 674.962,
    y2: 238.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2197_5367",
    x1: 441.458,
    y1: 358.938,
    x2: 494.23,
    y2: 374.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2197_5367",
    x1: -907.024,
    y1: -1056.68,
    x2: 663.611,
    y2: -511.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2197_5367",
    x1: -1842.38,
    y1: -2287.12,
    x2: 1232.83,
    y2: -1220.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2197_5367",
    x1: -2.21221,
    y1: -229.112,
    x2: 937.038,
    y2: 96.6244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2197_5367",
    x1: -635.148,
    y1: -1060.49,
    x2: 1321.16,
    y2: -382.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2197_5367",
    x1: 159.576,
    y1: 643.043,
    x2: 47.4464,
    y2: 627.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2197_5367",
    x1: 112.876,
    y1: 585.122,
    x2: 112.876,
    y2: 622.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2197_5367",
    x1: 112.876,
    y1: 582.854,
    x2: 112.876,
    y2: 775.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2197_5367",
    x1: 104.496,
    y1: 574.77,
    x2: 104.496,
    y2: 595.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2197_5367",
    x1: 121.258,
    y1: 574.77,
    x2: 121.258,
    y2: 595.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2197_5367",
    x1: 83.3469,
    y1: 697.734,
    x2: 207.35,
    y2: 714.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2197_5367",
    x1: 85.2494,
    y1: 685.276,
    x2: 204.971,
    y2: 701.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2197_5367",
    x1: 82.0186,
    y1: 713.647,
    x2: 194.409,
    y2: 670.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2197_5367",
    x1: 131.764,
    y1: 693.966,
    x2: 150.547,
    y2: 701.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2197_5367",
    x1: 128.543,
    y1: 710.136,
    x2: 156.368,
    y2: 721.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2197_5367",
    x1: 146.783,
    y1: 681.783,
    x2: 146.783,
    y2: 702.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2197_5367",
    x1: 130.117,
    y1: 681.783,
    x2: 130.117,
    y2: 702.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2197_5367",
    x1: 389.787,
    y1: 152.247,
    x2: 481.485,
    y2: 212.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00461489,
    stopColor: "#4EC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectmarketing);
export default __webpack_public_path__ + "static/media/projectmarketing.b12dc5f5ae20a49d531bb8cf85150f15.svg";
export { ForwardRef as ReactComponent };